import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import DashboardIcon from "@mui/icons-material/Menu";
// import DarkMode from "../pages/DarkMode";
import Minu from "../pages/Minu";
import dashboard from "../image/dashboard.png";
import User from "../image/add-user.png";
import product from "../image/car.png";
import profile from "../image/profile.png";
import logOut from "../image/log-out.png";
import Logoo from "../image/Logo.jpg";
import Facebook from "../image/facebook.jpg";
// import WhatSApp from "../image/whatisup.jpg";
import "../style/NavBar.css";
const NavBar = () => {
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 350,
      }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List sx={{ backgroundColor: "#white", padding: "20px" }}>
        <img src={Logoo} alt="logo" className="Logoo" />
        <ListItem button key="Dashboard" disablePadding>
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={dashboard}
              alt="Dashboard"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <ListItemText primary="dashboard" />
          </Link>
        </ListItem>
        <ListItem button key="Products" disablePadding>
          <Link
            to="/Products"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={product}
              alt="Products"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <ListItemText primary="Products" />
          </Link>
        </ListItem>
        <ListItem button key="User" disablePadding>
          <Link
            to="/User"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={User}
              alt="User"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <ListItemText primary="User" />
          </Link>
        </ListItem>

        {[
          // { icon: dashboard, text: t("dashboard") },
          // { icon: product, text: t("Allproducts") },
          // { icon: currencies, text: t("currencies") },
          // { icon: stock, text: t("stock") },
        ].map(({ icon, text }) => (
          <ListItem button key={text} disablePadding>
            {icon && <img src={icon} alt="icon" width={24} height={24} />}
          </ListItem>
        ))}
      </List>
      <Divider />
      <List sx={{ backgroundColor: "#white", padding: "30px" }}>
        {[
          {
            icon: (
              <img
                src={profile}
                alt="icon"
                width={24}
                height={24}
                style={{ marginRight: "10px" }}
              />
            ),
            text: "profile",
            link: "/Profile",
          },
          {
            icon: (
              <img
                src={logOut}
                alt="icon"
                width={24}
                height={24}
                style={{ marginRight: "10px" }}
              />
            ),
            text: "logout",

            onClick: () => {
              Cookies.remove("user");

              // localStorage.removeItem("sessionToken");
              window.location.href = "/";
            },
          },
        ].map(({ icon, text, link, onClick }) => (
          <ListItem button key={text} disablePadding onClick={onClick}>
            {icon}
            <span style={{ marginLeft: "10px" }}>
              {link ? (
                <Link
                  to={link}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <ListItemText primary={text} />
                </Link>
              ) : (
                text
              )}
            </span>
          </ListItem>
        ))}
        <br />
        {/* <DarkMode /> */}
        <ul className="navbar-info">
          <li>Make by</li>
          <li>
            <img
              src={Facebook}
              alt="Facebook"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <a
              href="https://www.facebook.com/TechTopia1998"
              target="_blank"
              rel="noopener noreferrer"
            >
              TechTopia
            </a>
          </li>
          {/* <li>
            <img
              src={WhatSApp}
              alt="WhatsApp"
              width={24}
              height={24}
              style={{ marginRight: "2px" }}
            />
            <a
              href="https://wa.link/1o8y3b"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span> </span>
              07811421542
            </a>
          </li> */}
        </ul>
      </List>
    </Box>
  );
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div>
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button
              variant="contained"
              color="success"
              onClick={toggleDrawer(anchor, true)}
              style={{ marginRight: "50px", borderRadius: 8 }}
              startIcon={<DashboardIcon />}
            >
              {anchor}
            </Button>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              sx={{ "& .MuiDrawer-paper": { width: "250px" } }}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>
      <Minu />
    </div>
  );
};

export default NavBar;
